<template>
  <div class="pt-0">
    <h1 class="mx-10 text-left text-xl font-bold" v-if="ciclismo.ciclismo">
      Total de Registro(s): {{ ciclismo.ciclismo.length }}
    </h1>

    <h1 class="mx-10 text-left text-xl font-bold animate-pulse" v-else>
      Aguarde um momento...
    </h1>
  </div>

  <br />

  <div class="mx-10 h-96 overflow-auto">
    <table class="m-auto hidden lg:block">
      <tr
        class="border-white-f2 border-4 md:border-2"
        style="background: #195493"
      >
        <th class="border-white-f2 border-r-4 md:border-r-2 py-4 capitalize">
          ID:
        </th>
        <th class="border-white-f2 border-r-4 md:border-r-2 py-4 capitalize">
          Nome:
        </th>
        <th class="border-white-f2 border-r-4 md:border-r-2 py-4 capitalize">
          Telefone:
        </th>
        <th class="border-white-f2 border-r-4 md:border-r-2 py-4 capitalize">
          Endereço:
        </th>
        <th class="border-white-f2 border-r-4 md:border-r-2 py-4 capitalize">
          E-mail:
        </th>
        <th class="border-white-f2 border-r-4 md:border-r-2 py-4 capitalize">
          Criado / Atualizado:
        </th>
      </tr>
      <tr
        v-for="{
          id,
          nome,
          tel,
          end,
          email,
          created_at,
          updated_at,
        } in ciclismo.ciclismo"
        :key="id"
        class="border-white-f2 border-4 md:border-2"
      >
        <th class="border-white-f2 border-r-4 md:border-r-2 py-5 px-2">
          <h1 class="text-md">{{ id }}</h1>
        </th>
        <th
          class="border-white-f2 border-r-4 md:border-r-2 py-5 px-2 capitalize"
        >
          <h1 class="text-md">{{ nome }}</h1>
        </th>
        <th class="border-white-f2 border-r-4 md:border-r-2 py-5 px-2">
          <h1 class="text-md">{{ tel }}</h1>
        </th>
        <th
          class="border-white-f2 border-r-4 md:border-r-2 py-5 px-2 capitalize"
        >
          <h1 class="text-md">{{ end }}</h1>
        </th>
        <th class="border-white-f2 border-r-4 md:border-r-2 py-5 px-2">
          <h1 class="text-md">{{ email }}</h1>
        </th>
        <th class="border-white-f2 border-r-4 md:border-r-2 py-5 px-2">
          <h1 class="text-md">{{ created_at }} / {{ updated_at }}</h1>
        </th>
      </tr>
    </table>

    <div
      v-for="{
        id,
        nome,
        tel,
        end,
        email,
        created_at,
        updated_at,
      } in ciclismo.ciclismo"
      :key="id"
      class="lg:hidden overflow-auto mb-10"
    >
      <table class="mobile">
        <tr class="mobile">
          <th class="mobile">ID:</th>
          <td class="mobile">{{ id }}</td>
        </tr>

        <tr class="mobile">
          <th class="mobile">nome:</th>
          <td class="mobile">{{ nome }}</td>
        </tr>

        <tr class="mobile">
          <th class="mobile">tel:</th>
          <td class="mobile">{{ tel }}</td>
        </tr>

        <tr class="mobile">
          <th class="mobile">end:</th>
          <td class="mobile">{{ end }}</td>
        </tr>

        <tr class="mobile">
          <th class="mobile">email:</th>
          <td class="mobile">{{ email }}</td>
        </tr>

        <tr class="mobile">
          <th class="mobile">Criado:</th>
          <td class="mobile">{{ created_at }}</td>
        </tr>

        <tr class="mobile">
          <th class="mobile">Atualizado:</th>
          <td class="mobile">{{ updated_at }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableApi",
  data() {
    return {
      ciclismo: [],
      total: "",
    };
  },
  methods: {
    puxarApi() {
      fetch(
        "https://api.pedalnoparaiso.duquedecaxias.rj.gov.br/consultar-cadastros"
      )
        .then((response) => response.json())
        .then((json) => {
          this.ciclismo = json;
        });
    },
  },
  watch: {
    url() {
      this.puxarApi();
    },
  },
  created() {
    console.log(this.puxarApi());
    this.puxarApi();
  },
};
</script>

<style scoped>
table.mobile {
  width: 100%;
  border-collapse: collapse;
}
/* Zebra striping */
tr:nth-of-type(odd) {
  background: rgba(255, 255, 255, 0.2);
}

th.mobile {
  background: #195493;
  color: white;
  font-weight: bold;
}
td.mobile,
th.mobile {
  padding: 6px;
  border: 1px solid #ccc;
  text-align: left;
}
</style>
